import React from 'react'

const EditIcon = ({ width, height, fill}) => (
    <svg 
        height={height}
        width={width}
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 24 24" 
        fill={fill}
    >
        <path 
            d="M18.5293 15.3193C18.7058 14.8934 19.2942 
            14.8934 19.4707 15.3193L19.7236 15.9307C20.1556 
            16.9735 20.9615 17.8062 21.9746 18.2568L22.6914 
            18.5762C23.1022 18.7589 23.1022 19.3564 22.6914 
            19.5391L21.9326 19.877C20.9449 20.3163 20.1534 
            21.1194 19.7139 22.1279L19.4668 22.6934C19.2863 
            23.1075 18.7136 23.1075 18.5332 22.6934L18.2861 
            22.1279C17.8466 21.1194 17.0551 20.3163 16.0674 
            19.877L15.3076 19.5391C14.8974 19.3562 14.8974 
            18.759 15.3076 18.5762L16.0254 18.2568C17.0385 
            17.8062 17.8444 16.9735 18.2764 15.9307L18.5293 
            15.3193ZM17.1426 11.0967L7.24219 20.9961H3V16.7539L12.8994 
            6.85451L17.1426 11.0967ZM16.4346 3.31838C16.8251 2.92785
            17.4591 2.92785 17.8496 3.31838L20.6777 6.14748C21.0681
            6.53802 21.0682 7.17108 20.6777 7.56154L18.5566 
            9.68263L14.3135 5.44044L16.4346 3.31838Z"
        >
        </path>
    </svg>
)
export default EditIcon